import React from 'react';
import { aboutContent } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="section section-light section-padding">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Title */}
          <div>
            <div className="gold-line mb-6" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-4">
              {aboutContent.title}
            </h2>
            <p 
              className="text-xl"
              style={{ color: 'var(--accent-gold)' }}
            >
              {aboutContent.subtitle}
            </p>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-6">
            {aboutContent.paragraphs.map((paragraph, index) => (
              <p 
                key={index}
                className="text-base md:text-lg"
                style={{ 
                  color: 'var(--text-secondary)',
                  lineHeight: '1.8'
                }}
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Decorative divider */}
        <div className="divider-gold mt-24" />
      </div>
    </section>
  );
};

export default AboutSection;
